import { render, staticRenderFns } from "./kegiatanPerpusDetile.vue?vue&type=template&id=70819b03&"
import script from "./kegiatanPerpusDetile.vue?vue&type=script&lang=js&"
export * from "./kegiatanPerpusDetile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QCard,QCardSection,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QCard,QCardSection,QImg})
